
import { condLegalesService } from "../../../_services/condicionesLegales.service";
import { dashboardConstants } from "../constants";

export const getCondLegales = () => async (dispatch) => {
  dispatch(request());
  try {
    const response = await condLegalesService.getCondLegales();

    if (typeof response === "string") {      
      dispatch(failure(response));
    } else {
      dispatch(success(response));
    }

  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_COND_LEG_LIST, payload: data };
  }
};


export const getCondLegal = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = condLegalesService.getCondLegal(id);
    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }

  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(data) {
    return { type: dashboardConstants.SET_COND_LEG, payload: data };
  }
};


export const deleteCondLegal = (id) => async (dispatch) => {
  dispatch(request());
  try {
    const data = condLegalesService.deleteCondLegal(id);

    if (typeof data === "string") {
      dispatch(failure(data));
    } else {
      dispatch(success(data));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_COND_LEG_LIST, payload };
  }
};

export const editCondLegal = (id, data) => async (dispatch) => {
  dispatch(request());
  try {
    const result = condLegalesService.editCondLegal(id, data);

    if (typeof result === "string") {
      dispatch(failure(result));
    } else {
      dispatch(success(result));
    }
  } catch (error) {
    dispatch(failure(error.toString()));
  }
  function request() {
    return { type: dashboardConstants.FETCH_STARTED };
  }
  function failure(payload) {
    console.error(payload);
    return { type: dashboardConstants.FETCH_ERROR, payload };
  }
  function success(payload) {
    return { type: dashboardConstants.SET_COND_LEG_LIST, payload };
  }
};
